module.exports = __webpack_public_path__ + "img/process.6ea7a1f0.png";